import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useProductUpdates } from '../../contexts/ProductUpdatesProvider';
import ProductUpdateForm from './ProductUpdateForm';
import ProductUpdateList from './ProductUpdateList';
import { NavBarMain } from "..";

export const ProductUpdates = () => {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [selectedUpdate, setSelectedUpdate] = useState(null);
  const { updates, isLoading, createUpdate, updateUpdate, deleteUpdate, refreshUpdates, hasFetched } = useProductUpdates();

  // Fetch updates when component mounts if not already fetched
  useEffect(() => {
    if (!hasFetched) {
      refreshUpdates();
    }
  }, [hasFetched, refreshUpdates]);

  const handleCreateUpdate = async (updateData) => {
    try {
      const result = await createUpdate(updateData);
      setShowForm(false);
    } catch (error) {
      // Error is already handled in the context
    }
  };

  const handleUpdateUpdate = async (_id, updateData) => {
    try {
      const result = await updateUpdate(_id, updateData);
      setShowForm(false);
      setSelectedUpdate(null);
    } catch (error) {
      // Error is already handled in the context
    }
  };

  const handleDeleteUpdate = async (_id) => {
    try {
      await deleteUpdate(_id);
    } catch (error) {
      // Error is already handled in the context
    }
  };

  const handleEdit = (update) => {
    setSelectedUpdate(update);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setSelectedUpdate(null);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <NavBarMain currentPage="bot" type="dashboard" />
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-white">{t('productUpdates')}</h1>
        <button
          onClick={() => {
            setSelectedUpdate(null);
            setShowForm(true);
          }}
          className="bg-[#E8FC8B] text-[#1B2D1A] px-4 py-2 rounded hover:bg-[#E8FC8B]/90"
        >
          {t('createNewUpdate')}
        </button>
      </div>

      <ProductUpdateForm
        show={showForm}
        onHide={handleCloseForm}
        update={selectedUpdate}
        onSubmit={selectedUpdate ? handleUpdateUpdate : handleCreateUpdate}
      />

      {isLoading ? (
        <div className="text-center text-white">{t('loading')}</div>
      ) : (
        <ProductUpdateList
          updates={updates}
          onEdit={handleEdit}
          onDelete={handleDeleteUpdate}
        />
      )}
    </div>
  );
}; 